<template>
	<div class="introduction">
		<Nav-bar></Nav-bar>
		<div class="banner">
			<span>产品介绍</span>
			<span>PRODUCT INTRODUCTION</span>
		</div>
		<div class="introduction-outer">
			<div class="introduction-inner">
				<div class="intro-item">
					<div class="intro-item-div">
						<div class="tit">
							<span>01</span>
							<span>送达服务</span>
						</div>
						<p>提供各类文书送达的信息化管理平台，实现全院文书集中送达、材料集中收转、全程留痕留证。</p>
						<p>为司法文书送达服务，提供专业的驻场服务专员，为法官、书记员提供贴身的、为院方提供定制化的、为当事人提供暖心的文书送达服务。</p>
					</div>
					<img src="../../assets/images/cpjs-img1.png" >
				</div>
				<div class="intro-item" >
					<img src="../../assets/images/cpjs-img3.png" >
					<div class="intro-item-div">
						<div class="tit">
							<span>02</span>
							<span>审判辅助事务</span>
						</div>
						<p>为了提高审判质效、降低司法运行成本、 减轻法官书记员的工作负担，便利当事人的诉讼活动。</p>
						<p>通过集约化的送达服务平台以延伸出案件流转跟踪平台、诉前保全平台、 诉前调解管理平台，中间库等综合管理平台，为审判服务工作提速、增效，实现全程留痕留证。</p>
					</div>
				</div>
				<div class="intro-item">
					<div class="intro-item-div">
						<div class="tit" style="margin-top: 50px;">
							<span>03</span>
							<span>调解业务</span>
						</div>
						<p>自2020年12月入驻北京某法院至2022年2月底，调解业务小组累计接收各类案件共计14817件，调解成功率达30.00%。调解业务部稳步发展，因其自身的专业性、规范性，调解人员准确掌握法律适用，在法治的框架和轨道内释法说理讲情，让调解变得有温度，化解矛盾坚冰，一面面锦旗就是人民群众对我们工作最大的认可。</p>
					</div>
					<img src="../../assets/images/cpjs-img4.png" >
				</div>
				<div class="intro-item">
					<img src="../../assets/images/cpjs-img2.png" >
					<div class="intro-item-div">
						<div class="tit">
							<span>04</span>
							<span>财产保全</span>
						</div>
						<p>为了提高审判质效、降低司法运行成本、减轻法官书记员的工作负担，便利当事人的诉讼活动。</p>
						<p>通过集约化的送达服务平台以延伸出案件流转跟踪平台、诉前保全平台、诉前调解管理平台，中间库等综合管理平台，为审判服务工作提速、增效，实现全程留痕留证.</p>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { defineComponent, watch, ref } from "vue";
import Foot from "../../components/foot/index.vue"
import NavBar from "../../components/navbar/index.vue"
export default defineComponent({
  name: "Introduction",
	components:{
		Foot,
		NavBar
	},
	setup(){
	
	}
})
</script>
<style lang="scss" scoped>
.introduction {
	width: 100%;
	height: 100%;
	.banner {
		width: 100%;
		height: 530px;
		background: url(../../assets/images/cpjs-bg.png);
		display: flex;
		flex-direction: column;
		align-items: center;
		span:nth-child(1) {
			margin-top: 180px;
			font-size: 70px;
			font-family: PingFang SC;
			font-weight: 800;
			color: #FFFFFF;
		}
		span:nth-child(2) {
			margin-top: 20px;
			font-size: 24px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}
	}
	.introduction-outer {
		width: 100%;
		padding: 70px;
		background-color: #ffffff;
		.introduction-inner {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			.intro-item {
				width: 100%;
				height: 360px;
				display: flex;
				justify-content: space-between;
				img {
					height: 360px;
					width: auto;
				}
				.intro-item-div {
					width: 670px;
					height: 100%;
					.tit {
						margin-top: 10px;
						display: flex;
						align-items: center;
						span:nth-child(1) {
							font-size: 50px;
							font-family: DIN;
							font-weight: bold;
							color: #0759BB;
						}
						span:nth-child(2) {
							font-size: 34px;
							font-family: PingFang SC;
							font-weight: 800;
							color: #333333;
							margin-left: 10px;
						}
					}
					p {
						font-size: 18px;
						font-family: PingFang SC;
						font-weight: bold;
						color: #333333;
						line-height: 40px;
						margin-top: 30px;
					}
				}
			}
			.intro-item:nth-child(n+2) {
				margin-top: 40px;
			}
		}
	}
}
</style>